import {
  TaskStatus,
  WorkflowCode,
  type GetQSetByTaskIdQuery,
  type QConfig,
  type QConfigMetadata,
} from '@exam-management/graphql';
import {
  QSetReviewWorkflowStepCodeObject,
  type QSetReviewWorkflowStepCode,
} from '@exam-management/task-management';

import type { Subtask } from '../types';

interface TransformQSetReviewSubtaskDetailsDataProps {
  subTask?: Subtask;
  qSet?: GetQSetByTaskIdQuery['excGetQSetByTaskId']['qSet'];
}
export function transformQSetReviewSubtaskDetailsData(
  props?: Readonly<TransformQSetReviewSubtaskDetailsDataProps>,
) {
  const { subTask: data, qSet } = props ?? {};
  const qSetMetadata =
    data?.metadata.__typename === 'TaskMetadataWithQSet' ? data.metadata.qSet : undefined;
  const qConfig = qSetMetadata?.qConfig;

  return {
    id: data?.id ?? '',
    name: data?.parentTask?.name ?? '',
    code: data?.code ?? '',
    updatedAt: data?.updatedAt ?? new Date(),
    dueDate: data?.dueDate ?? new Date(),
    status: data?.status ?? TaskStatus.Todo,
    assignee: {
      id: data?.assignee.id ?? '',
      firstname: data?.assignee.firstname ?? '',
      lastname: data?.assignee.lastname ?? '',
    },
    assignerId: data?.assignerId ?? '',
    ownerId: data?.ownerId ?? '',
    workflowId: data?.workflowId ?? '',
    ownerName: data?.owner ? `${data.owner.firstname} ${data.owner.lastname}` : '',
    currentWorkflowStepId: data?.currentWorkflowStepId ?? '',
    currentWorkflowStep: {
      name: data?.currentWorkflowStep.name ?? '',
      code:
        (data?.currentWorkflowStep.code as QSetReviewWorkflowStepCode | undefined) ??
        QSetReviewWorkflowStepCodeObject.QsetReviewTodo,
      workflowCode: WorkflowCode.ReviewQSet,
    },
    examId: qSetMetadata?.examCourse.examId.toString() ?? '',
    examCode: qSetMetadata?.examCourse.code ?? '',
    examTitle: qSetMetadata?.examCourse.name ?? '',
    examCourse: {
      code: qSetMetadata?.code ?? '',
      name: qSetMetadata?.examCourse.name ?? '',
    },
    score: qConfig?.structures.reduce((acc, curr) => acc + curr.score, 0) ?? 0,
    qSet: {
      id: qSetMetadata?.id ?? '',
      code: qSetMetadata?.code ?? '',
      pAvgValue: qSetMetadata?.pAvgValue ?? 0,
      examCourseId: qSetMetadata?.examCourse.code ?? '',
      conditions: qSet?.conditions ?? null,
      qConfig: {
        fullScore: qConfig?.fullScore ?? 0,
        metadata: qConfig?.metadata as QConfigMetadata,
        structures: qConfig?.structures as QConfig['structures'],
        totalQuestions: qConfig?.totalQuestions as QConfig['totalQuestions'],
      },
    },
  };
}
